import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=957846b2&scoped=true&"
import script from "./UserEditDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957846b2",
  null
  
)

export default component.exports